<template>
    <v-container class="pa-2">
        <v-card>
            <v-card-title class="title">
                Resultado Consulta Motor
            </v-card-title>
        
        <v-card-text v-if="showResultado" >
            <v-divider></v-divider>
            <v-row class="caption">
                <v-col>
                    Resultado: {{consultaCredito.resultado}}
                </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-row class="caption">
                <v-col>
                    Oferta: {{consultaCredito.oferta}}
                </v-col>
            </v-row>
            <v-divider></v-divider>
           <v-row class="caption">
               <v-col>
                Tope Cuota: $ {{consultaCredito.cupo}} / Tope Producto: $ {{consultaCredito.topeProducto}}
                </v-col>
            </v-row>
            <v-divider></v-divider>

            <v-row class="caption d-flex align-center">
                <v-col>
                ID Consulta: {{consultaCredito.respuestaMotorId}}
                </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-row class="pa-2">
                <v-col>
                <v-chip :color="colorEstado" class="caption align-right"> {{consultaCredito.estado}}</v-chip>  
                </v-col>
            </v-row>
        </v-card-text>

        <v-card-actions v-if="showResultado">
            <v-btn @click="showVariablesMotor=true">Ver Variables del Motor</v-btn>
        </v-card-actions>
    </v-card>

    <!-- variables motor -->
    <v-dialog v-model="showVariablesMotor" width="1000">
        <app-variables-motor :ConsultaMotorId="consultaCredito.respuestaMotorId"></app-variables-motor>
    </v-dialog>

    </v-container>    
</template>

<script>

import Vue from 'vue'
import { http } from '@/axios'

export default {
    data () {
        return {
            loading: false,
            showVariablesMotor: false
        }
    },
    props:{
        consultaCredito: {
            type: Object,
        },
    },
    computed: {
        showResultado: function(){
            return this.consultaCredito && this.consultaCredito.id && this.consultaCredito.id != "00000000-0000-0000-0000-000000000000";
        },
        colorEstado: function(){
            if(!this.consultaCredito.estado) return;

            if(this.consultaCredito.estado == "APROBADO CON CUPO") return "green";
            if(this.consultaCredito.estado == "APROBADO SIN CUPO") return "yellow";
            if(this.consultaCredito.estado == "RECHAZADO") return "red";
        }
    },
    watch:{
        consultaCredito: function(){

        }
    },
    methods:{
        // async loadconsultaCredito(){
        //     if(!this.showResultado ) return;

        //     this.loading = true
        //     try {
        //         var result = await http.get('consultasmotorsiisa/establecerpoliticacomercial'
        //         + '?productoId='+ this.model.productoId
        //         + '&empresaId='+ this.model.empresaId 
        //         + '&canalVentaId='+ this.model.canalVentaId
        //         + '&calificacionPersonaId='+ this.infoCrediticia.tipoCalificacionId); 
                
        //     } catch (error) {
        //         // Error
        //         this.alertError(error)
        //     }
        //     this.loading = false
        // }
    }
    
}
</script>